import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const LoyaltyVIPLogoBlack: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--loyalty-VIP-logo-icon')}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g fill="none" fillRule="evenodd">
      <polygon
        fill="#000"
        transform="translate(12.000000, 11.500000) rotate(-180.000000) translate(-12.000000, -11.500000) "
        points="12 20 8.41666667 12.1104715 3 17.4123199 5.25 3 18.75 3 21 17.4123199 15.5833333 12.1104715"
      />
    </g>
  </svg>
);

export default LoyaltyVIPLogoBlack;
